import BaseController from 'chairisher/_controller';

/**
 * Controller that binds actions for the Privacy Request Confirmation page
 */
class PrivacyRequestConfirmationController extends BaseController {
    /** @inheritdoc */
    bindPageActions() {
        super.bindPageActions();
        window.setTimeout(() => {
            window.location.href = '/';
        }, 4000);
    }
}

export default PrivacyRequestConfirmationController;
